module.exports = __webpack_public_path__ + "img/8.7af60d3f.jpg";